module.exports = __webpack_public_path__ + "../resources/img/ic_scrolltop_active.920e3fac.svg";